export default "__VITE_ASSET__ChHns2dm__"